module.exports = __webpack_public_path__ + "img/ForkLift.75c8a7f1.svg";